<app-layout-dialogheader1 [title]="'O&M Panel inspection'" [titlesub]="panelInfo" mat-dialog-title>
</app-layout-dialogheader1>
<mat-dialog-content>
  <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
  <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>


  <form [formGroup]="myform" class="" (ngSubmit)="saveModel()">
    <p class="form-hint">Fields with * are required</p>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label" for="status"><span class="required-asterisk">*</span>Status</label>
      <div class="col-sm-9">
        <select id="status" formControlName="status" class="form-control form-control-sm" required
          [ngClass]="!myform.get('status').valid ? 'is-invalid' :'' ">
          <option [ngValue]="null" disabled>Select status</option>
          <option [ngValue]="'TOREVIEW'">
            {{OMItem_getDescription('TOREVIEW')}}
          </option>
          <option [ngValue]="'INPROGRESS'">
            {{OMItem_getDescription('INPROGRESS')}}
          </option>                    
          <option [ngValue]="'PENDING'">
            {{OMItem_getDescription('PENDING')}}
          </option>
          <option [ngValue]="'REVIEWED'">
            {{OMItem_getDescription("REVIEWED")}}
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="myform.get('status').hasError('required')">
          Status is required
        </div>
      </div>
    </div>

    <div class="form-group row">

      <div class="col-sm-3 ">
        <label class="col-form-label" for="reviewedDate"><span class="required-asterisk">*</span> Date
        </label>
        <!-- <div class="input-hint">Date to review, about the revision. </div> -->
      </div>
      <div class="col">
        <mat-form-field class="mat-form-control-sm disabledreadable" style="max-width: 16em;">
          <input matInput class="mat-form-field disabledreadable" [matDatepicker]="picker2"
            formControlName="reviewedDate" required>
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-3 ">
        <label class="col-form-label" for="panel_serial">Panel Serial number</label>        
      </div>
      <div class="col-sm-9">
        <input class="form-control form-control-sm" id="panel_serial" formControlName="panel_serial" type="text"
          placeholder="Panel serial number">
      </div>
    </div>    

    <div class="form-group row">
      <div class="col-sm-3 ">
        <label class="col-form-label" for="comments">Comments</label>
        <div class="input-hint">Information about the revision. </div>
      </div>
      <div class="col-sm-9">
        <textarea class="form-control form-control-sm" id="comments" formControlName="comments" rows="4"
          placeholder="Description about panel revision"></textarea>
      </div>
    </div>

  </form>

</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">
  <button mat-raised-button type="button" (click)="saveModel()" [disabled]="!isvalid()||submitted"
    class="btn btn-success pull-right"><i class="far fa-save"></i> Save</button>
  <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>